import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconComponent } from './icon.component';

@NgModule({
  exports: [IconComponent],
  imports: [CommonModule, IconComponent],
})
export class IconModule {}
